import { __APP_NAME__ } from "config/static";

export default function Footer() {
  return (
    <div className={`self-end flex justify-center w-full bg-mainLight mt-4`}>
      <footer
        className={`w-full shadow p-2 py-2.5 mx-auto max-w-6xl text-white`}
      >
        <div
          className={`w-full mx-auto p-4 flex justify-center flex-col md:flex-row items-center md:justify-between`}
        >
          <span className="text-sm font-bold sm:text-center mx-auto">
            <a
              href="https://www.facebook.com/share/16MoDb7K1u/"
              className="hover:underline text-white px-1"
            >
              {__APP_NAME__} ...
            </a>
            بدل عملتك بكل سهولة ...
          </span>

          {/* <span className="text-sm font-bold sm:text-center">
            تصميم وتطوير{" "}
            <a
              href="https://wa.me/963960062941"
              className="text-yellow-500/80 hover:underline"
            >
              byRings
            </a>
          </span> */}
        </div>
      </footer>
    </div>
  );
}
